import React from 'react';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { setModalId, usePublicState } from '../../store/slices/publicSlice';
import CustomModal from '../atoms/CustomModal';
import Button from '../atoms/Button';
import Logo from '../../assets/icons/Logo';

export default function PreviewFile() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { modalId, modalExtraData } = usePublicState();

  const isModalOpened = modalId === 'VIEW_FILE';
  const data = modalExtraData as { url?: string; type?: 'IMAGE' | 'VIDEO' } | undefined;

  const onClose = () => {
    dispatch(setModalId(null));
  };

  return (
    <CustomModal
      isOpen={isModalOpened}
      onClose={onClose}
      title=""
      closable={true}
      centered
    >
      <div className="space-y-4">
        <div className="flex items-center -mt-2">
          <Logo className="w-[35px] md:w-[50px]" />
        </div>
        <div className="h-[400px] w-full flex items-center justify-center bg-gray-50 dark:bg-gray-900 rounded-lg overflow-hidden">
          {data?.type === 'IMAGE' ? (
            <img
              src={data?.url}
              className="w-full h-full object-contain rounded-lg"
              alt="Preview"
            />
          ) : data?.type === 'VIDEO' ? (
            <video controls className="w-full h-full rounded-lg" autoPlay>
              <source src={data?.url} />
            </video>
          ) : null}
        </div>

        <div className="flex justify-end pt-2">
          <Button
            type="button"
            onClick={onClose}
            className="!px-8 !py-2 !h-auto !rounded-lg"
          >
            {t('done', 'Done')}
          </Button>
        </div>
      </div>
    </CustomModal>
  );
}
